module.exports = __webpack_public_path__ + "static/img/materialsInfo3.5a23277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo3.png
// module id = Hv2H
// module chunks = 2